type MxGraphCircleInput = {
  percent: number;
};

type MxGraphCircleType = MxGraphCircleInput &
  React.HTMLAttributes<HTMLDivElement>;

export const MxGraphCircle = ({
  percent,
  className,
  ...props
}: MxGraphCircleType) => (
  <div className={`${className} relative`} {...props}>
    <svg
      width="200"
      height="200"
      viewBox="0 0 200 200"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M200 100C200 155.228 155.228 200 100 200C44.7715 200 0 155.228 0 100C0 44.7715 44.7715 0 100 0C155.228 0 200 44.7715 200 100ZM20 100C20 144.183 55.8172 180 100 180C144.183 180 180 144.183 180 100C180 55.8172 144.183 20 100 20C55.8172 20 20 55.8172 20 100Z"
        fill="#EDEDED"
      />
      {percent < 100 ? (
        <path
          d="M100 0C124.351 0 147.865 8.88528 166.131 24.9889C184.397 41.0925 196.159 63.3077 199.211 87.4667C202.263 111.626 196.395 136.068 182.708 156.208C169.021 176.349 148.455 190.802 124.869 196.858C101.283 202.914 76.2979 200.156 54.601 189.101C32.9041 178.046 15.9866 159.453 7.02236 136.812C-1.94184 114.171 -2.33668 89.0376 5.91192 66.1262C14.1605 43.2148 30.4857 24.1005 51.8246 12.3693L61.4597 29.8955C44.3885 39.2804 31.3284 54.5719 24.7295 72.901C18.1307 91.2301 18.4465 111.337 25.6179 129.45C32.7892 147.563 46.3233 162.436 63.6808 171.281C81.0383 180.125 101.026 182.331 119.895 177.487C138.764 172.642 155.217 161.079 166.166 144.967C177.116 128.854 181.811 109.301 179.369 89.9733C176.928 70.6461 167.518 52.874 152.905 39.9911C138.292 27.1082 119.481 20 100 20L100 0Z"
          fill="#C41719"
        />
      ) : (
        <path
          d="M200 100C200 44.7715 155.228 0 100 0C44.7715 0 0 44.7715 0 100C0 155.228 44.7715 200 100 200C155.228 200 200 155.228 200 100ZM20 100C20 55.8172 55.8172 20 100 20C144.183 20 180 55.8172 180 100C180 144.183 144.183 180 100 180C55.8172 180 20 144.183 20 100Z"
          fill="#C41719"
        />
      )}
    </svg>
    <div className="absolute inset-0 top-[7rem] h-full w-full text-center">
      <div className="flex flex-col">
        <div className="text-[1.6rem] font-semibold">You keep</div>
        <div className="text-[3.2rem] text-brand-secondary md:text-[4rem]">
          {percent}%
        </div>
      </div>
    </div>
  </div>
);
